import { autoinject } from 'aurelia-framework';
import {DialogController} from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';

@autoinject
export class SaveChangesDialog {
    constructor(protected controller: DialogController, private api: WebApiService) {
    }

    activate() {
    }

}